import { authHttpClient } from '@webmotors/consumer-shared-auth';
import type { TAdvertiserSource } from '@stores/advertiser';

/** Serviço REST para buscar dados do anunciante logado. */
export const advertiserRestService = {
  async fetchAdvertiser(): Promise<TAdvertiserSource> {
    const response = await authHttpClient.post(
      `${import.meta.env.VITE_API_PF_URL}v1/acesso/dados-usuario`,
      { hash: '' },
    );

    return response.data;
  },
};
